import {FilterBlock, FilterBlockType, FilterState} from "../TableFilter";
import Toggle from "../../Toggle";
import React from 'react';
import {ButtonColour} from "../../ButtonColour";
import UIRadio from "../../form/UIRadio";
import TextButton from "../../TextButton";

type Props = {
  data: RadioFilterBlock;
  state: FilterState
  onToggle: (data: FilterState) => void;
}

export default function UIRadioFilterBlock({data, state, onToggle}: Props) {
  const {id, name, title, radios} = data;
  const checkedIds = state.value.split(',');
  const withState = radios.map(x => ({...x, checked: checkedIds.indexOf(x.id) >= 0}));

  const onClear = () => {
    onToggle(new FilterState(id, false, ''));
  };

  const onRadioChange = (value: string) => {
    onToggle(new FilterState(id, true, value));
  };

  return (
    <div className="py-4 px-3">
      <div className="flex flex-row justify-between">
        <span className="font-bold">{title}</span>
        {state.active &&
          <button onClick={() => onClear()} className="ml-4 text-blue">Clear</button>
        }
      </div>
      <div className="flex flex-col mt-4">
        {withState.map((value, index) => (
          <UIRadio id={value.id} key={value.id} name={name} label={value.label} checked={value.checked}
                      onChange={onRadioChange}/>
        ))}
      </div>
    </div>
  );
}

export type RadioValue = {
  id: string;
  value: string;
  label: string;
  checked: boolean;
}

export class RadioFilterBlock implements FilterBlock {
  readonly type: FilterBlockType = FilterBlockType.RADIO;

  constructor(readonly id: string, readonly title: string, readonly name: string, readonly radios: RadioValue[]) {
  }
}
